import React from "react";

const ButtonSpinner = ({ size = 18, color = "#fff" }) => {
  return (
    <>
      <span
        style={{
          display: "inline-block",
          width: size,
          height: size,
          border: `2px solid rgba(255, 255, 255, 0.3)`,
          borderTop: `2px solid ${color}`,
          borderRadius: "50%",
          animation: "btn-spin 0.6s linear infinite",
          verticalAlign: "middle",
        }}
      />
      <style>{`@keyframes btn-spin { to { transform: rotate(360deg); } }`}</style>
    </>
  );
};

export default ButtonSpinner;
